import { useLocation, useNavigate } from 'react-router-dom';

const hasActiveHospitalSession = () => {
    const hospitalId = sessionStorage.getItem('hospitalId');
    const hospitalTime = Number.parseInt(sessionStorage.getItem('hospitalTime'), 10);

    return Boolean(hospitalId) && Number.isFinite(hospitalTime) && Date.now() < hospitalTime;
};

const MobileFooter = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const goToHospitalPage = (path) => {
        if (hasActiveHospitalSession()) {
            navigate(path);
            return;
        }

        navigate('/', {
            state: {
                hospitalCodeError: 'Please enter hospital code',
            },
        });
    };

    const navigationItems = [
        { label: 'Home', icon: 'bi-house-door-fill', path: '/', onClick: () => navigate('/') },
        { label: 'Dashboard', icon: 'bi-speedometer2', path: '/dashboard', onClick: () => goToHospitalPage('/dashboard') },
        { label: 'Customer', icon: 'bi-people-fill', path: '/verify', onClick: () => goToHospitalPage('/verify') },
    ];

    return (
        <nav className="mobile-footer" aria-label="Primary navigation">
            {navigationItems.map(({ label, icon, path, onClick }) => (
                <button
                    key={label}
                    type="button"
                    className={`mobile-footer__item${location.pathname === path ? ' mobile-footer__item--active' : ''}`}
                    aria-current={location.pathname === path ? 'page' : undefined}
                    onClick={onClick}
                >
                    <i className={`bi ${icon}`} aria-hidden="true" />
                    <span>{label}</span>
                </button>
            ))}
        </nav>
    );
};

export default MobileFooter;
